import React, { useState } from 'react';
import { fade, makeStyles } from '@material-ui/core/styles';
import clsx from 'clsx';
import Grid from '@material-ui/core/Grid';
import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';
import Button from '@material-ui/core/Button';
import CardMedia from '@material-ui/core/CardMedia';
import Chip from '@material-ui/core/Chip';
import CardContent from '@material-ui/core/CardContent';
import CardActions from '@material-ui/core/CardActions';
import Collapse from '@material-ui/core/Collapse';
import Avatar from '@material-ui/core/Avatar';
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import { red } from '@material-ui/core/colors';
import {Box, TablePagination} from '@material-ui/core';
import EditIcon from '@material-ui/icons/Edit';
import DeleteIcon from '@material-ui/icons/Delete';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import Tooltip from '@material-ui/core/Tooltip';
import ConfirmationDialog from '../../components/ConfirmationDialog/ConfirmationDialog';
import * as RFIcon from 'react-feather';

import { ReactComponent as CabinIllustration } from "../../illustrations/cabin.svg";
import { Badge } from '@material-ui/core';
import language from '../../languages';

const useStyles = makeStyles((theme) => ({
    root: {
        margin: -6
    },
    card: {
        width: '100%',
        cursor: 'pointer',
        '&:hover': {
            backgroundColor: fade('#F4F5F6', 0.25)
        }
    },
    media: {
        height: 0,
        paddingTop: '56.25%', // 16:9
    },
    avatarMedia: {
        width: 150,
        height: 150,
        backgroundSize: 'cover',
        backgroundPosition: 'top center',
        borderRadius: '50%',
        margin: '4px 25%'
    },
    expand: {
        transform: 'rotate(0deg)',
        marginLeft: 'auto',
        transition: theme.transitions.create('transform', {
            duration: theme.transitions.duration.shortest,
        }),
    },
    expandOpen: {
        transform: 'rotate(180deg)',
    },
    avatar: {
        backgroundColor: red[500],
    },
    deleteTitle:{
        padding: '8px 16px',
        color: '#ffffff',
        backgroundColor: '#2735A4',
    },
    deleteButton: {
      color: '#2735A4',
      margin: '8px 8px;',
      textTransform: 'capitalize',
      borderColor: '#2735A4'
    },
    deleteConfirmButton: {
        color: '#ffffff',
        backgroundColor: '#3076CA',
        '&:hover': {
          backgroundColor: fade('#3076CA', 0.75),
        },
        margin: '8px 8px;',
        textTransform: 'capitalize'
    },
}));

export default function BaseCard(props) {
    const classes = useStyles();
    const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
    const [deleteRow, setDeleteRow] = useState(null);
    const [rowsPerPage, setRowsPerPage] = React.useState(5);
    const { meta, readOnly, pager, setPageNumber, setItemsPerPage, showFilter, showDetail, onEdit, sidePanelDetailId, lang } = props;

    const handleChangePage = (event, newPage) => {
        const { setPageNumber } = props;
        setPageNumber(newPage);
    };
    
    const handleChangeRowsPerPage = (event) => {
        debugger;
        setRowsPerPage(parseInt(event.target.value, 10));
        //setPage(0);
    };

    const subStr = (str, limit) => {
        return (str && str.length > limit) ? str.substring(0,limit)+'...' : str
    }

    return (
        <Grid container mb={2} spacing={2} className={classes.root}>
            {
                <ConfirmationDialog
                    dialogProps={{
                        open: deleteDialogOpen,
                        onClose: () => { },
                    }}
                    content={
                        <>
                        <div className={classes.deleteTitle}><Typography variant="h6" >{language[lang].Delete}</Typography></div>
                        <Box p={4} width='600px'>
                            <Box p={2} >
                            <Typography variant="subtitle2" >{language[lang].Confirm_Message} {props.meta.entityName}?</Typography>
                            </Box>
                        </Box>
                        </>
                    }
                    dismissiveAction={<Button variant="outlined" className={classes.deleteButton} onClick={() => { setDeleteRow(null); setDeleteDialogOpen(false) }}>{language[lang].Cancel}</Button>}
                    confirmingAction={<Button variant="contained" className={classes.deleteConfirmButton}  onClick={() => { props.onDelete(deleteRow); setDeleteDialogOpen(false) }}>{language[lang].Delete}</Button>}
                />
            }
            {
                props.rows && (props.rows.length > 0 )? props.rows.map((row) => {
                    const titleField = subStr(row[meta.card.title.field], 20)
                    const longText = subStr(row[meta.card.description.field], 100)
                    return (<Grid item xs={12} sm={6} md={4} lg={showFilter ? 4 : 3} key={row[meta.card.key.field]} >
                        <Card className={classes.card} style={sidePanelDetailId == row.id ? {backgroundColor: '#F3F6FF'} : {}}
                         onClick={(e) => {!readOnly && meta.hideAction && meta.displaySidePanel ? showDetail(row) : onEdit(row)}} >
                            { (meta.hideHeader ? !meta.hideHeader : true) && <CardHeader
                                avatar={
                                    meta.card.showBadge
                                    ?
                                        <Badge badgeContent={row[meta.card.badgeContent.field]} 
                                            invisible={row[meta.card.showBadge.field]}
                                            anchorOrigin={{vertical: 'bottom', horizontal: 'right',}}
                                        > 
                                            <Avatar src={row[meta.card.image.field]} className={classes.avatar}>
                                                {row[meta.card.avatar]}
                                            </Avatar>
                                        </Badge>
                                    :
                                        <Avatar src={row[meta.card.image.field]} className={classes.avatar}>
                                            {row[meta.card.avatar]}
                                        </Avatar>
                                }
                                action={
                                    <IconButton aria-label="settings">
                                        <MoreVertIcon />
                                    </IconButton>
                                }
                                title={titleField}
                                subheader={row[meta.card.subTitle.field]}

                            />}
                            <CardMedia
                                className={meta.card.image.type == 'avatar' ? classes.avatarMedia : classes.media}
                                image={row[meta.card.image.field] || 'https://via.placeholder.com/800'}
                            // title="Paella dish"
                            />
                            <CardContent style={meta.card.getContentStyle ? meta.card.getContentStyle() : {}}>
                                {   meta.card.getDescription ?  meta.card.getDescription(row) :
                                    <Typography variant="subtitle2" component="p">
                                        {longText}
                                    </Typography>
                                }
                            </CardContent>
                            <CardActions>
                                {
                                    meta.card.getFooter(row)
                                    // meta.card.tags.map((tag, i) => {
                                    //     if(row[tag.field])
                                    //         return <Chip key={i} label={row[tag.field]} color={tag.color && tag.getColors(row[tag.field])} style={{margin:'0 2px'}} />
                                    // })
                                }
                            </CardActions>

                            {
                                !readOnly && !meta.hideAction && <CardActions disableSpacing>
                                    {/* {
                            meta.card.actions.map((action, i) => {
                                let comp = null;
                                comp = <IconButton key={i} aria-label={action.label} onClick={(e)=> props.onEdit(row)}>
                                        {action.getIcon}
                                    </IconButton>
                                return comp
                            })
                        } */}
                                    <Tooltip title={language[lang].Edit} placement="bottom">
                                        <IconButton aria-label="Edit" component="span"
                                            onClick={() => props.onEdit(row)}>
                                            <RFIcon.Edit color='#000000' strokeWidth={2} />
                                        </IconButton>
                                    </Tooltip>
                                    <Tooltip title={language[lang].Delete} placement="bottom">
                                        <IconButton aria-label="Delete" component="span"
                                            onClick={() => { setDeleteRow(row); setDeleteDialogOpen(true); }}>
                                            <RFIcon.Trash2 color='#DE4646' strokeWidth={2} />
                                        </IconButton>
                                    </Tooltip>

                                </CardActions>
                            }
                        </Card>
                    </Grid>)
                }) : <h2>{language[lang].No_Data}</h2>

            }
            <Grid item xs={12}>
            <TablePagination
                // rowsPerPageOptions={[4, 12, 24]}
                rowsPerPageOptions={[12]}
                component="div"
                count={pager.totalCount}
                rowsPerPage={pager.itemsPerPage}
                page={pager.pageNo}
                onChangePage={(e, newPage) => setPageNumber(newPage)}
                onChangeRowsPerPage={(e) => setItemsPerPage(e.target.value)}
            />
            </Grid>
        </Grid>
    );
}